/* Rising Sun FPV - Halloween logo flicker (V2.7, sizing fix in V4.0). The header logo briefly glitches to ghostly green: soon after the page loads,
   every 9-16 seconds after that, and when someone hovers over it. Only runs between the dates set in
   Customize > Theme settings > Halloween logo flicker (Brisbane time), and never for visitors who've turned on reduce motion. */
(function () {
  var d = document, me = d.currentScript;
  var start = me && me.getAttribute('data-start'), end = me && me.getAttribute('data-end');
  var today = new Date(Date.now() + 10 * 3600000).toISOString().slice(0, 10);
  if (start && today < start) return;
  if (end && today > end) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var GREEN = 'hue-rotate(105deg) saturate(1.4) brightness(1.1) drop-shadow(0 0 6px rgba(109, 255, 159, 0.75))';
  var css = '' +
    '.rs-ghost{position:relative}' +
    /* V4.0: the copies start at 0 x 0 until run() sizes them to the logo. At their natural size (4096 px wide) they
       stretched the page sideways until the first flicker, or for the whole visit in a background tab. */
    '.rs-ghost__layer{position:absolute;left:0;top:0;width:0;height:0;pointer-events:none;opacity:0;max-width:none!important;filter:' + GREEN + '}' +
    '.rs-ghost.is-ghosting .header__logo-image{animation:rsGhostMain 1.2s linear both}' +
    '.rs-ghost.is-ghosting .rs-ghost__layer--slice{animation:rsGhostSlice 1.2s steps(1,end) both}' +
    '.rs-ghost.is-ghosting .rs-ghost__layer--rise{animation:rsGhostRise 1.2s ease-out both}' +
    '@keyframes rsGhostMain{0%,100%{opacity:1;filter:none;transform:none}6%{opacity:.35;filter:none}10%{opacity:1;filter:' + GREEN + '}' +
      '22%{transform:translateX(-2px)}26%{transform:translateX(2px) skewX(-4deg)}30%{transform:none}44%{opacity:.5}50%{opacity:1}' +
      '82%{filter:' + GREEN + '}90%{filter:none}}' +
    '@keyframes rsGhostSlice{0%,13%,41%,100%{opacity:0;clip-path:inset(0 0 100% 0);transform:none}' +
      '14%{opacity:.9;clip-path:inset(12% 0 62% 0);transform:translateX(-7px)}20%{clip-path:inset(58% 0 18% 0);transform:translateX(6px)}' +
      '27%{clip-path:inset(30% 0 46% 0);transform:translateX(-4px)}34%{clip-path:inset(70% 0 6% 0);transform:translateX(8px)}' +
      '40%{opacity:.9;clip-path:inset(40% 0 40% 0);transform:translateX(-3px)}}' +
    '@keyframes rsGhostRise{0%,48%{opacity:0;transform:none}52%{opacity:.55;transform:none}100%{opacity:0;transform:translateY(-10px) scale(1.04)}}';

  function setup() {
    var links = [];
    Array.prototype.forEach.call(d.querySelectorAll('.header__logo-link'), function (link) {
      var img = link.querySelector('.header__logo-image');
      if (!img || link.classList.contains('rs-ghost')) return;
      if (!d.getElementById('rs-ghost-css')) {
        var style = d.createElement('style');
        style.id = 'rs-ghost-css';
        style.textContent = css;
        d.head.appendChild(style);
      }
      link.classList.add('rs-ghost');
      var layers = ['slice', 'rise'].map(function (k) {
        var c = img.cloneNode(false);
        c.removeAttribute('style');
        c.removeAttribute('id');
        c.className = 'rs-ghost__layer rs-ghost__layer--' + k;
        c.alt = '';
        c.setAttribute('aria-hidden', 'true');
        link.appendChild(c);
        return c;
      });
      links.push({ link: link, img: img, layers: layers, busy: false, last: 0 });
    });
    return links;
  }

  function run(g) {
    if (g.busy || Date.now() - g.last < 1500 || d.visibilityState === 'hidden') return;
    var w = g.img.offsetWidth, h = g.img.offsetHeight;
    if (!w || !h) return;
    g.layers.forEach(function (c) {
      c.style.left = g.img.offsetLeft + 'px';
      c.style.top = g.img.offsetTop + 'px';
      c.style.width = w + 'px';
      c.style.height = h + 'px';
    });
    g.busy = true;
    g.link.classList.add('is-ghosting');
    setTimeout(function () { g.link.classList.remove('is-ghosting'); g.busy = false; g.last = Date.now(); }, 1250);
  }

  function init() {
    var ghosts = setup();
    if (!ghosts.length) return;
    ghosts.forEach(function (g) {
      g.link.addEventListener('mouseenter', function () { run(g); });
      g.link.addEventListener('focus', function () { run(g); });
    });
    function every() { ghosts.forEach(run); setTimeout(every, 9000 + Math.random() * 7000); }
    var waited = 0;
    (function first() {
      /* Wait for the airlock intro to finish on a first visit, so the logo is actually visible */
      if (d.documentElement.classList.contains('rs-booting') && waited < 12000) { waited += 500; setTimeout(first, 500); return; }
      setTimeout(every, 2200);
    })();
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();